import React, { useEffect, useState } from 'react'
import { nearbyresource } from '../../../../services/chatFlowService'
import { addSiteAddress, Addsitedetails, deleteZoneDetails, updateSiteAddress, Updatesitedetails } from '../../../../services/configurationServices'
import { ErrorToast } from '../../../../CustomHooks/ErrorToast'
import { SuccessToast } from '../../../../CustomHooks/SuccessToast'
import Swal from 'sweetalert2'

const ZoneDetailsForm = ({ site, country, countryState, isFormEdit, setIsFormEdit, selectedZone, setSelectedZone, getZoneList}) => {
console.log("site9",site)
  const [zoneName, setZoneName] = useState('')
  const [zoneNameError, setZoneNameError] = useState("")
  const [branchName, setBranchName] = useState("");
  const [branchNameError, setBranchNameError] = useState("");

  useEffect(() => {
    if (selectedZone != null) {
      setZoneName(selectedZone?.SiteName)
      setBranchName(selectedZone?.BranchID)
      setZoneNameError("")
      setBranchNameError("");
    }
  }, [selectedZone])

  const clearForm = () => {
    setZoneName('')
    setZoneNameError('')
    setBranchName('');
    setBranchNameError('')
    setIsFormEdit(false)
    setSelectedZone(null)
  }

  const onSaveZone = async () => {
    let isValidate = false

    if (zoneName === "") {
      setZoneNameError("Please enter zone name!")
      isValidate = true;
    }

    if(branchName === ""){
      setBranchNameError("Please enter branch id!")
      isValidate = true;
    }

    if(isValidate){
      return;
    }

    let user = JSON.parse(localStorage.getItem("user"));
    var _lat = 0;
    var _long = 0;
    var objNearByResources = {
      SearchPlace: site?.Address,
      radius: 0,
      lat: 0,
      long: 0,
      SearchType: "PlaceDetails",
    };
    await nearbyresource(objNearByResources).then((resp1) => {
      if (resp1.status == "Ok") {
        if (resp1.message.length > 0) {
          _lat = resp1.message[0].siteLattitude;
          _long = resp1.message[0].siteLongitude;
        }
      }
    });
    if (selectedZone == null) {
      let addZoneObj = {
        UserID: user.Id,
        ParentID: site?.SiteID.toString(),
        SiteName: zoneName,
        Lattitude: _lat.toString(),
        Longitude: _long.toString(),
        PinUrl: "",
        Alt: "",
        IsBingMap: "",
        BranchID: branchName,
        SolID: "",
        SiteModeID: site?.SiteModeID.toString(),
        SiteTypeID: "3", //Zone
        TopicArn: "",
        ClientId: site?.clientID.toString(),
        OrganizationMasterID: user.OrganizationMasterID.toString(),
      }
      addSiteDetails(addZoneObj, site?.Address, site?.CountryId, site?.StateId, site?.Region, site?.Area, site?.City, site?.pincode, user, zoneName, site?.BranchID, site?.clientID, site?.SiteModeID)
    } else {
      let updateZoneObj = {
        UserID: user.Id,
        SiteID: selectedZone.SiteID?.toString(),
        ParentID: selectedZone.ParentId.toString(),
        SiteName: zoneName,
        Lattitude: _lat.toString(),
        Longitude: _long.toString(),
        PinUrl: "",
        Alt: "",
        IsBingMap: "",
        BranchID: branchName,
        SolID: "",
        SiteModeID: site?.SiteModeID.toString(),
        SiteTypeID: "3", //Zone
        TopicArn: "",
        ClientId: site?.clientID.toString(),
        OrganizationMasterID: user.OrganizationMasterID.toString(),
        CreatedOn: "",
        CreatedBy: "",
        ModifiedOn: "",
        ModifiedBy: user.Id,
        UpdatedateTime: "",
      }
      updateSiteDetails(
        updateZoneObj,
        selectedZone, // Will need the site address id.
        site?.Address,
        site?.CountryId, site?.StateId, site?.Region, site?.Area, site?.City, site?.pincode,
        user
      );
    }
  }

  const addSiteDetails = (
    siteObj,
    siteaddress,
    tempCountryName,
    tempCountryStateName,
    siteRegionName,
    siteaArea,
    cityName,
    sitePincode,
    user,
    sitename,
    branchid,
    clientID,
    SiteModeID
  ) => {
    Addsitedetails(siteObj).then((resp) => {
      if (resp.Status == "success") {
        //Here to add in site address table.
        let addressObj = {
          Siteid: resp.Data.SiteID.toString(),
          Address: siteaddress,
          Countryid: tempCountryName.toString(),
          Stateid: tempCountryStateName.toString(),
          Region: siteRegionName,
          Area: siteaArea,
          City: cityName,
          PinCode: sitePincode,
          CreatedOn: "",
          ModifiedON: "",
          Createdby: user.Id,
          ModifiedBy: "",
          OrganizationMasterID: user.OrganizationMasterID.toString(),
          UpdatedateTime: "",
          UserID:user.Id
        };
        addSiteAddress(addressObj).then((res) => {
          if (res.Status == "success") {
            // Call Get Zone Sites
            getZoneList(site?.SiteID);
            SuccessToast(resp.Message);
            clearForm();

            let tempObj = {
              SiteID: resp.Data.SiteID,
              SiteName: sitename,
              BranchID: branchid,
              Address: siteaddress,
              clientID: clientID,
              AddCustomerName: "",
              CountryId: tempCountryName[0].countrymasterid,
              StateId: tempCountryStateName[0].statemasterid,
              City: cityName,
              Region: siteRegionName,
              pincode: sitePincode,
              Area: siteaArea,
              SiteModeID: SiteModeID,
            };
            // setSelectedSite(tempObj);
            // setIsSiteEdit(false);
            window.scrollTo({ top: 500, left: 0, behavior: "smooth" });
            setTimeout(() => {
              let siteDiv = document.getElementById("siteListDiv");
              siteDiv.scrollTo({
                top: siteDiv.scrollHeight,
                behavior: "smooth",
              });
            }, 1000);
          } else {
            ErrorToast(resp.Message);
            // setButtonDisable(false);
          }
        });
      } else {
        ErrorToast(resp.Message);
        // setButtonDisable(false);
      }
    });
  };
const deleteSiteZone = async (siteid) => {
        var myCurrentDatetime = new Date();
        let userId = localStorage.getItem("UserID");
        // let obj = {
        //   SiteID: siteid,
        //   UserID: userid,
        //   SiteDeleteTime: _datetime,
        // };
        console.log("siteid206",siteid)
        await deleteZoneDetails(userId, siteid).then((resp) => {
          
          if (resp.Status == "success") {
            getZoneList(site.SiteID);
            setIsFormEdit(false);
            console.log("resp.Message",resp.Message)
            SuccessToast(resp.Message);
            clearForm()
            return;
          } else if (resp.Status == "failed") {
            Swal.fire({ text: resp.Message });
          } else {
            Swal.fire({ text: "Something went wrong, please try again later!" });
          }
        });
      };
console.log("selectedZone223",selectedZone)
  function onDeleteZone(e, siteid, name) {
      e.stopPropagation();
      Swal.fire({
        title: "Are you sure?",
        text: `You really want to delete ${name} zone!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          deleteSiteZone(siteid);
        }
      });
    }
  const updateSiteDetails = (
    updateObj,
    siteData,
    siteaddress,
    tempCountryName,
    tempCountryStateName,
    siteRegionName,
    siteaArea,
    cityName,
    sitePincode,
    user
  ) => {
    Updatesitedetails(updateObj).then((resp) => {
      if (resp.Status == "success") {
        let updateAddressObj = {
          AddressId: siteData.AddressId.toString(),
          Siteid: resp.Data.SiteID.toString(),
          Address: siteaddress,
          Countryid: tempCountryName.toString(),
          Stateid: tempCountryStateName.toString(),
          Region: siteRegionName,
          Area: siteaArea,
          City: cityName,
          PinCode: sitePincode,
          CreatedOn: "",
          ModifiedON: "",
          Createdby: "",
          ModifiedBy: user.Id,
          OrganizationMasterID: user.OrganizationMasterID.toString(),
          UpdatedateTime: "",
          UserID:user.Id
        };
        updateSiteAddress(updateAddressObj).then((res) => {
          if (res.Status == "success") {
            // Call Zone Site List
            getZoneList(site?.SiteID);
            setIsFormEdit(false);
            clearForm();
            // setButtonDisable(false);
            SuccessToast(resp.Message);
          } else {
            ErrorToast(resp.Message);
            // setButtonDisable(false);
          }
        });
      } else {
        ErrorToast(resp.Message);
        // setButtonDisable(false);
      }
    });
  };

  return (
    <>
      <div className="siteformContainer">
        <form>
          <div className="site-form" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Zone Name</label>
                <input
                  className="inputType"
                  placeholder="Zone Name"
                  value={zoneName}
                  disabled={isFormEdit}
                  onChange={(e) => {
                    setZoneName(e.target.value)
                    setZoneNameError("")
                  }}
                />
                <p className="Error_P" style={{ float: "left" }}><span>{zoneNameError}</span></p>
              </div>
            </div>

            {/* <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Zone Icon</label>
                        <select className="inputType ArrowSelectClass">
                        <option key="0" disabled={false} value="0">Select Zone Icon</option>
                        <option>Customer 1</option>
                        <option>Customer 1</option>
                        <option>Customer 1</option>
                        </select>
                    </div>
                    <p className="Error_P" style={{ float: "left" }}><span></span></p>
                </div> */}

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Latitude</label>
                <input
                  className="inputType"
                  placeholder="Latitude"
                  disabled={true}
                  value={site?.Lattitude}
                />
                <p className="Error_P" style={{ float: "left" }}><span></span></p>
              </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Longitude</label>
                <input
                  className="inputType"
                  placeholder="Longitude"
                  disabled={true}
                  value={site?.Longitude}
                />
                <p className="Error_P" style={{ float: "left" }}><span></span></p>
              </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Address One</label>
                <input
                  className="inputType"
                  placeholder="Address One"
                  disabled={true}
                  value={site?.Address}
                />
                <p className="Error_P" style={{ float: "left" }}><span></span></p>
              </div>
            </div>

            {/* <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>Address Two</label>
                    <input 
                        className="inputType"
                        placeholder="Address Two"
                    />
                    <p className="Error_P" style={{ float: "left" }}><span></span></p>
                    </div>
                </div> */}

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Select Region</label>
                <input
                  className="inputType"
                  placeholder="Region"
                  disabled={true}
                  value={site?.Region}
                />
                <p className="Error_P" style={{ float: "left" }}><span></span></p>
              </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Select Area</label>
                <input
                  className="inputType"
                  placeholder="Area"
                  disabled={true}
                  value={site?.Area}
                />
                <p className="Error_P" style={{ float: "left" }}><span></span></p>
              </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Select Country</label>
                <select className="inputType ArrowSelectClass" disabled={true} value={site?.CountryId}>
                  <option key="0" disabled={false} value="0" id="0">Select Country*</option>
                  {country &&
                    country.map((val) => (
                      <option value={val.countrymasterid} key={val.countrymasterid} id={val.countrymasterid}>
                        {val.countryname}
                      </option>
                    ))}
                </select>
                <p className="Error_P" style={{ float: "left" }}><span> </span></p>
              </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Select State</label>
                <select className="inputType ArrowSelectClass" disabled={true} value={site?.StateId}>
                  <option key="0" disabled={false} value="0">Select State*</option>
                  {countryState &&
                    countryState.map((val) => (
                      <option value={val.statemasterid} key={val.statemasterid}>
                        {val.statename}
                      </option>
                    ))}
                </select>
                <p className="Error_P" style={{ float: "left" }}><span></span></p>
              </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Select City</label>
                <input
                  className="inputType"
                  placeholder="Select City*"
                  disabled={true}
                  value={site?.City}
                />
                <p className="Error_P" style={{ float: "left" }}><span></span></p>
              </div>
            </div>


            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Pin Code</label>
                <input
                  className="inputType"
                  placeholder="Pin code"
                  disabled={true}
                  value={site?.pincode}
                />
                <p className="Error_P" style={{ float: "left" }}><span></span></p>
              </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Branch ID</label>
                <input
                  className="inputType"
                  placeholder="Branch Id"
                  disabled={isFormEdit}
                  value={branchName}
                  onChange={(e) => {
                    setBranchName(e.target.value)
                    setBranchNameError("")
                  }}
                />
                <p className="Error_P" style={{ float: "left" }}><span>{branchNameError}</span></p>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div style={{ textAlign: "center" }}>
        {
          isFormEdit
          &&
          <button className="DataAccessEdit" style={{ width: "100px" }} onClick={clearForm}>
            <span className="ViewUpdate">Add New</span>
          </button>
        }
        {
          isFormEdit
          &&
          <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => setIsFormEdit(false)}>
            <span className="ViewUpdate">Edit</span>
          </button>
        }
        {
          !isFormEdit
          &&
          <button className="DataAccessEdit" style={{ width: "100px" }} onClick={onSaveZone}>
            <span className="ViewUpdate">Save</span>
          </button>
        }
        {
          isFormEdit
          &&
          <button className="DataAccessEdit" style={{ width: "100px" }} onClick={(e)=>onDeleteZone(e,selectedZone.SiteID,selectedZone.SiteName)}>
            <span className="ViewUpdate">Delete</span>
          </button>
        }
      </div>
    </>
  )
}

export default ZoneDetailsForm